import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({ providedIn: 'root' })
export class EventSwitcherTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackOpen(eventId: string): void {
        this.trackAction('Expand', eventId, 'Event Switcher');
    }

    trackClose(eventId: string, isLive: boolean): void {
        this.trackAction('Close', eventId, 'Close', undefined, isLive);
    }

    trackEventSelect(currentEventId: string, selectedEventId: string, selectedEventName: string, selectedLive: boolean): void {
        this.trackAction('Select', currentEventId, selectedEventName, selectedEventId, selectedLive);
    }

    private trackAction(action: string, currentEventId: string, eventDetail: string, selectedEventId?: string, selectedLive?: boolean): void {
        const trackingObject: {
            'component.CategoryEvent': string;
            'component.LabelEvent': string;
            'component.ActionEvent': string;
            'component.PositionEvent': string;
            'component.LocationEvent': string;
            'component.EventDetails': string;
            'component.URLClicked': string;
            'sportEventId'?: string;
        } = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Event Switcher',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'Events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: action,
            [trackingConstants.COMPONENT_POSITION_EVENT]: currentEventId,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: selectedLive ? 'inplay' : 'preevent',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetail,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };

        if (selectedEventId) {
            trackingObject['sportEventId'] = selectedEventId;
        }

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingObject);
    }
}
